<template>
  <div class="queryContent">
     <div class="breadcrumb">
      <Breadcrumb separator=">">
        <BreadcrumbItem to="/">{{ $t("nav.home") }}</BreadcrumbItem>
        <BreadcrumbItem>{{ $t("query.type.rateE") }} </BreadcrumbItem>
      </Breadcrumb>
    </div>

    <div class="query-header scroll-border-dom">
      <div class="query-header-wrap">
      
        <div class="inputs-wrap">
          <Tabs v-model="currentQueryType" >
            <TabPane label="出口税率" name="export" ></TabPane>
            <!-- <TabPane label="出口查询" name="export" icon="logo-windows"></TabPane> -->
          </Tabs>
          <div class="query-inputs">
            <div class="inputs clearfix" @keyup="escEvent">
              <!-- <template v-if="currentQueryType == 'import'">
                <Export class="ex" ref="ex" :width="'200%'" :currentState="currentState" styleName="n" @handleClick="handleClick" @closeDropdown="closeDropdown"></Export>
                <Import class="im" ref="im" :width="'200%'" :currentState="currentState" styleName="n" @handleClick="handleClick" @closeDropdown="closeDropdown"></Import>
              </template> -->
              <template>
                <Export class="ex" ref="ex" :width="'200%'" :currentState="currentState" styleName="n" @handleClick="handleClick" @closeDropdown="closeDropdown"></Export>
                <Import class="im" ref="im" :width="'200%'" :currentState="currentState" styleName="n" @handleClick="handleClick" @closeDropdown="closeDropdown"></Import>
                <Product class="pr"      placeholderText="商品编码/商品英文名称" ref="pr" :currentState="currentState" styleName="n" :countrycode="countrycode" @handleClick="handleClick" @closeDropdown="closeDropdown"></Product>
            
              </template>
             
            </div>
            <div class="btn-wrap clearfix">
              <Button type="primary" class="btn search" @click.prevent="searchHandle">
                <span v-if="!isShowLoader"><span>搜索</span></span>
                <span v-else>{{$t('common.loading')}}</span>
              </Button>
              <Button class="btn reset" type="primary" @click.prevent="resetHandle" :disabled="isShowLoader"><span>{{$t('btn.reset')}}</span></Button>
            </div>
            <!-- <Watermark></Watermark> -->
          </div>
        </div>
      </div>
    </div>
    <div class="results">
      <div class="results-wrap">
        <div class="results-content">
        
          <RateContentZH :best="best" :ranks="ranks" :dataSet="ftas" :hsData="hsData" :currentQueryType="currentQueryType" :exporterData="exporterData" :importerData="importerData" :exporterID="exporter" :importerID="importer" :hscode="hscode"/>
        </div>
      </div>
      <Loader :loadType="1" v-show="isShowLoader" class="black"></Loader>
      <!-- <Watermark></Watermark> -->
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import Export from '../common/Export'
import Import from '../common/Import'
import Product from '../common/ProductE'
import RateContentZH from './zh-CN/RateContent'
import Loader from '../layout/Loader'
import Velocity from 'velocity-animate'
import Watermark from '../common/Watermark.vue'
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapSearchState, mapMutations: mapSearchMutations } = createNamespacedHelpers('search')
const { mapState: mapDataState, mapGetters: mapDataGetters } = createNamespacedHelpers('data')

export default {
  name: 'Rate',
  props: ['exporter', 'importer', 'hscode'],
  components: { Import, Export, Product, RateContentZH, Loader, Watermark },
  data () {
    return {
      currentQueryType: 'export',
      $isIE: Vue._customVars.isIE,
      searchItem: {},
      isShowLoader: false,
      importerData: {},
      exporterData: {},
      hsData: {},
      ftas: [],
      ranks: [],
      best: {},
      t: '',
      countrycode:null,
      searchDoing: false,
      isShowSearchMsg: true,
      changeTab: ''
    }
  },
  watch: {
    productReady (newVal, oldVal) {
      if (newVal) {
        setTimeout(() => {
          this.initInputValue()
        }, 200)
      }
    },
    exporter (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.initInputValue()
        this.requestData()
      }
    },
    importer (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.initInputValue()
        this.requestData()
      }
    },
    hscode (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.initInputValue()
        this.requestData()
      }
    },
    $route () {
      this.t = this.$route.query._t
    },
    currentQueryType () {
      setTimeout(() => {
        this.valueSync()
      }, 50)
    },
    t (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$refs.ex.setDefaultValue({
          id: this.$route.params.exporter,
          text: this.$route.query.text
        });
        this.initInputValue()
        this.requestData()
      }
    }
  },
  computed: {
    currentState: {
      get () {
        return this.getActiveName()
      },
      set (v) {
        this.updateState(v)
      }
    },
    ...mapSearchState({
      historyExportItem: state => state.history.exporter,
      historyImportItem: state => state.history.importer,
      historyProductItem: state => state.history.products
    }),
    apiPrice () {
      if (this._.isEmpty(this.apiValue)) {
        return null
      } else {
        return this.getApiValue()
      }
    },
    ...mapDataState([
      'productReady'
    ]),
    ...mapDataState({
      apiValue: state => state.apiValue
    })
  },
  created () {
    if(this.$route.params.importer!=1){
     
         this.countrycode = this.$route.params.importer
    }
    this.currentState = 'rate'
    this.requestData()
  },
  mounted () {
    this.onTabSwitch()
    this.$nextTick(() => {
      this.currentState = 'rate'
      if (!this._.isEmpty(this.getTopProduct()())) {
        this.initInputValue()
      }
       if (this.$route.params.hscode != 1) {
        this.$refs.pr.setDefaultValue({ id: this.$route.params.hscode });
      }
      if (this.$route.params.exporter != 1) {
        this.$refs.ex.setDefaultValue({
          id: this.$route.params.exporter,
          text: this.$route.query.text
        });
       
        this.$refs.im.setDefaultValue({
          id: this.$route.params.importer,
          text: this.$route.query.texti
        });
      }

      this.$root.$on('QuickShowEvent', () => {
        this.currentState = 'rate'
        try {
          this.closeAllDropdown(!this.$data.$isIE)
        } catch (e) {}
      })
      let queryHeaderDom = document.querySelector('.query-header')
      let resultDom = document.querySelector('.results')
      let footer = document.querySelector('footer')
      resultDom.style.minHeight = (this._h.getWinHeight() - this._h.getOuterElSize(footer).height - Math.abs(this._h.getScrollTop() - Math.abs(this._h.getOffset(queryHeaderDom).bottom))) + 'px'
    })
  },
  methods: {
    valueSync () {
      this.$refs.ex.$el.style.display = 'block'
      this.$refs.im.$el.style.display = 'block'
      this.$refs.ex.$el.style.width = '1%'
      this.$refs.ex.$el.style.opacity = 0
      this.$refs.im.$el.style.width = '1%'
      this.$refs.im.$el.style.opacity = 0
      this.$refs.pr.$el.style.width = '1%'
      this.$refs.pr.$el.style.opacity = 0
      Velocity(this.$refs.ex.$el, { width: '29%', opacity: 1 }, { duration: 250 })
      Velocity(this.$refs.im.$el, { width: '29%', opacity: 1 }, { duration: 250, delay: 50 })
      Velocity(this.$refs.pr.$el, { width: '42%', opacity: 1 }, { duration: 250, delay: 50 })
    },
    onTabSwitch () {
      if(this.changeTab !== this.currentQueryType) {
     
        

        this.best = {}
        this.ranks = []
        this.hsData = {}
        this.ftas = []
        this.importerData = {}
        this.exporterData = {}
      }
      this.changeTab = this.currentQueryType
    },
    delayRequestData () {
      setTimeout(() => {
        this.requestData()
      }, 500)
    },
    requestData () {
      if (this.isShowLoader) {
        // this.delayRequestData()
        return
      }
      if (this.importer == 1 && this.hscode == 1 && this.exporter == 1) return
      if(this.importer == 27)  {
      
        this.$Message.error({content: '目的地不能是中国', closable: false})
        return
      }

   
      if(this.importer && this.exporter && this.importer == this.exporter){
        this.$Message.error({content: '目的地和起运地不能相同', closable: false})
        return
      }
    

      this.$Loading.start()
      this._h.scrollTop()
      this.isShowLoader = true

      this.$api.query.exportTax(this.importer, this.exporter, this.hscode, {
        success: (response) => {
          this.$Loading.finish()
          this.$refs.pr && this.$refs.pr.closeDowndown(false);
          if (response.data.code === 200) {
            if (!this._.isEmpty(response.data.data)) {
              this.importerData = response.data.data.importer
              this.exporterData = response.data.data.exporter
              this.hsData = response.data.data.hs
              this.ftas = response.data.data.ftas
              let ranks = response.data.data.ranks
              let arr = []

              for (let index = 0; index < ranks.length; index++) {
                if(!arr.find(item=>item.name==ranks[index].name)){
                  arr.push({name:ranks[index].name,children:[{...ranks[index]}]})
                }
                else{
                  arr.map(item=>{
                    if(item.name==ranks[index].name){
                      item.children.push({...ranks[index]})
                    }
                  })
                }
                
                
              }
              this.ranks = arr
              this.best = response.data.data.best
            } else {
              this.$Message.warning({content: this.$t('query.message.search_none'), closable: true})
            }
          } else if (response.data.code === 404) {
            this.$Message.warning({content: this.$t('query.message.search_none'), closable: true})
          // } else if (response.data.code === 505) {
          //   this.GMessage('warning', this.$t('query.message.search_frequent'), '去充值', { name: 'Recharge' })
          } else if (response.data.code === 401) {
            // this.GMessage('warning', this.$t('query.message.search_perm_limit2'), '登录', { path: '/my' })
            this.$Message.error({content: this.$t('query.message.search_perm_limit2'), closable: false})
          // } else if (response.data.code === 506) {
          //   this.GMessage('warning', this.$t('query.message.search_perm_limit'), '登录', { path: '/my' })
          } else {
           
            this.$Message.warning({content: response.data.message, closable: true})
          }
          this.isShowLoader = false
        },
        error: (errorMsg) => {
          this.isShowLoader = false
          this.$Message.error({content: this.$t('common.tryAgain'), closable: true})
          this.$Loading.error()
        }
      })
    },
    initInputValue () {
      let exporterItem = this.getExporterById()(this.exporter)
      let impoterItem = this.getImporterById()(this.importer)
      let productItem = this.getProductByCode()(this.hscode)
      if (!this._.isEmpty(exporterItem) && !this._.isEmpty(impoterItem) && !this._.isEmpty(productItem)) {
        this.$refs.ex.setDefaultValue({id: exporterItem.id, text: exporterItem.name})
        this.$refs.im.setDefaultValue({id: impoterItem.id, text: impoterItem.name})
        this.$refs.pr.setDefaultValue({id: productItem.code, text: productItem.name})
        this.searchItem = {exporter: exporterItem, impoter: impoterItem, product: productItem}
      } else if (!this._.isEmpty(this.historyExportItem) && !this._.isEmpty(this.historyImportItem) && !this._.isEmpty(this.historyProductItem)) {
        // this.$refs.ex.setDefaultValue(this.historyExportItem[0])
        // this.$refs.im.setDefaultValue(this.historyImportItem[0])
        // this.$refs.pr.setDefaultValue(this.historyProductItem[0])
        // this.searchItem = {exporter: this.historyExportItem[0], impoter: this.historyImportItem[0], product: this.historyProductItem[0]}
      }
    },
    resetHandle () {
       this.$refs.ex && this.$refs.ex.resetContent(false);
      this.$refs.im && this.$refs.im.resetContent(false)
      this.$refs.pr && this.$refs.pr.resetContent(false)
      this.best = {}
      this.ranks = []
      this.hsData = {}
      this.ftas = []
      this.importerData = {}
      this.exporterData = {}
    },
    searchByOther (hasDropdown = false) {
      this.searchDoing = false
      if (this.$refs.ex.text && !this.$refs.ex.value.id) {
        if (!hasDropdown && this.isShowSearchMsg) {
          this.$Message.warning({content: this.$t('query.message.export_error'), closable: true})
        }
        this.isShowSearchMsg = true
        return
      }
      if (this.$refs.im.text && !this.$refs.im.value.id) {
        if (!hasDropdown && this.isShowSearchMsg) {
          this.$Message.warning({content: this.$t('query.message.import_error'), closable: true})
        }
        this.isShowSearchMsg = true
        return
      }
       if (!this.$refs.pr.text) {
        if (!hasDropdown && this.isShowSearchMsg) {
          this.$Message.warning({content: this.$t('query.message.product_error'), closable: true})
        }
        this.isShowSearchMsg = true
        return
      }
      this.jfNotice2()
    },
    searchHandle () {
      if (this.searchDoing) return
      this.searchDoing = true
      if (!this.$refs.ex || !this.$refs.im || !this.$refs.pr) return
      if (this.$refs.ex.isShowDropDown || this.$refs.im.isShowDropDown || this.$refs.pr.isShowDropDown) {
        setTimeout(() => {
          this.searchByOther(true)
        }, 150)
      } else {
        this.searchByOther()
      }
    },
    jfNotice2 () {
      if (this.$i18n.locale === 'zh-CN') {
        this.GJFNotice(status => {
          if (status) {
            let jf = this.getApiValue()(1)
            if (jf && jf.integral && jf.integral > 0) {
              this.GConfirm(`本次查询将消耗${jf.integral}积点，当天重复查询不再扣除积点。`, status => {
                if (status) {
                  this.searchHandleAfter()
                }
              })
            } else {
              this.searchHandleAfter()
            }
          } else {
            this.searchHandleAfter()
          }
        })
      } else {
        this.searchHandleAfter()
      }
    },
    searchHandleAfter () {
      if (!this.$refs.ex || !this.$refs.im || !this.$refs.pr) return

      this.$refs.ex && this.$refs.ex.setValueFromDefaultPlaceholder()
      this.$refs.im && this.$refs.im.setValueFromDefaultPlaceholder()
      if (!this.$refs.ex.text) {
        this.$Message.warning({content: this.$t('query.message.export_empty'), closable: true})
        return
      }
      if (!this.$refs.ex.value.id) {
        this.$Message.warning({content: this.$t('query.message.export_error'), closable: true})
        return
      }
      if (!this.$refs.im.text) {
        this.$Message.warning({content: this.$t('query.message.import_empty'), closable: true})
        return
      }
      if (!this.$refs.im.value.id) {
        this.$Message.warning({content: this.$t('query.message.import_error'), closable: true})
        return
      }
      if (this.$refs.ex.value.id === this.$refs.im.value.id) {
        this.$Message.warning({content: this.$t('query.message.notEqu'), closable: true})
        return
      }
      this.$refs.pr && this.$refs.pr.setValueFromDefaultPlaceholder()
      if (!this.$refs.pr.text) {
        this.$Message.warning({content: this.$t('query.message.product_empty'), closable: true})
        return
      }
      if (!this.$refs.pr.text) {
        this.$Message.warning({content: this.$t('query.message.product_error'), closable: true})
        return
      }
      this.updateHistory({
        exporter: this.$refs.ex.value,
        importer: this.$refs.im.value,
        products: this.$refs.pr.value
      })
      
      switch (this.currentState) {
       
        case 'rate':
          this.$router.push({
            name: 'queryRateE',
            params: {
              exporter: this.$refs.ex.value.id,
              importer: this.$refs.im.value.id,
               hscode: this.$refs.pr.text
            },
            query: {
              _t: (new Date()).getTime(),
              text: this.$refs.ex.value.text,
              texti:this.$refs.im.value.text,
            }
          })
          break
      }
    },
    handleClick (event, componentName) {
      switch (componentName) {
        case 'exporter':
          this.$refs.im.closeDowndown(false)
          this.$refs.pr.closeDowndown(false)
          break
        case 'importer':
          this.$refs.ex.closeDowndown(false)
          this.$refs.pr.closeDowndown(false)
          break
        case 'product':
          this.$refs.ex.closeDowndown(false)
          this.$refs.im.closeDowndown(false)
          break
      }
    },
    enterEvent (event, componentName) {
      switch (componentName) {
        case 'ex':
          if (this.$refs.ex.text) {
            this.setAutomatic(componentName)
          }
          break
        case 'im':
          if (this.$refs.im.text) {
            this.setAutomatic(componentName)
          }
          break
        case 'pr':
          if (this.$refs.pr.text) {
            this.setAutomatic(componentName)
          }
          break
      }
      setTimeout(() => {
        // if (this.$refs.ex.value.id && this.$refs.im.value.id && this.$refs.pr.value.id) {
        this.isShowSearchMsg = false
        this.searchHandle()
        // }
      }, 300)
    },
    escEvent (event) {
     
    },
    tabEvent (event, componentName) {
      this.setAutomatic(componentName)
    },
    closeDropdown (event, componentName) {
      this.setAutomatic(componentName, false)
    },
    closeAllDropdown (isBlur = true) {
      this.$refs.ex.closeDowndown(isBlur)
      this.$refs.im.closeDowndown(isBlur)
      this.$refs.pr.closeDowndown(isBlur)
    },
    setAutomatic (componentName, isNextDropDown = true) {
      switch (componentName) {
        case 'ex':
          this.$refs.ex.closeDowndown(true)
          if (isNextDropDown || this.$refs.ex.text) {
            if (!this.$refs.im.text) {
              this.$refs.im.inputClick()
            } else if (!this.$refs.pr.text) {
              this.$refs.pr.inputClick()
            }
          }
          break
        case 'im':
          this.$refs.im.closeDowndown(true)
          this.countrycode = this.$refs.im.value.id;
          if (isNextDropDown || this.$refs.im.text) {
            if (!this.$refs.pr.text) {
              this.$refs.pr.inputClick()
            }
          }
          break
        case 'pr':
          this.$refs.pr.closeDowndown(true)
          break
      }
    },
    ...mapSearchState({
      getActiveName: state => state.activeName
    }),
    ...mapSearchMutations([
      'updateState',
      'updateHistory'
    ]),
    ...mapDataGetters([
      'getApiValue',
      'getExporterById',
      'getImporterById',
      'getProductByCode',
      'getTopProduct'
    ])
  }
}
</script>
<style scoped>
.query-tp{
  background-color: #fff;
  margin-bottom: 30px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, .2);
}
>>>.ivu-tabs-nav .ivu-tabs-tab-active {
  /* color: #2d8cf0; */
  color: #333;
  font-size: 16px;
  padding: 8px 30px;
  border-bottom: 4px solid #2d8cf0;
  font-weight: bold;
}
.query-stitle{
  color: #323232;
  font-weight: bold;
  font-size: 15px;
  padding: 14px 18px 4px;
}
  .ex, .im{
    width: 29%;
    float: left;
    border-right: 0 none !important;
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
  }
  .pr{
    width: 42%;
    float: left;
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
  }
  .im{
    border-radius: 0;
  }
  .results{
    position: relative;
  }
  .queryContent{
    background-color: #fff;
  }
  .inputs-wrap{
    background-color: #fff;
    padding: 12px 0 20px;
    border-radius: 3px;
    box-shadow: 0 1px 6px rgba(0, 0, 0, .2);
  }
  .query-tp >>> .ivu-tabs .ivu-tabs-bar{
    border-bottom-width: 0.5px;
    margin-bottom: 0;
  }
  .query-tp >>> .ivu-tabs .ivu-tabs-ink-bar{
    background-color: #0470e3;
    height: 3px;
    width: 145px !important;
  }
  .query-tp >>> .ivu-tabs .ivu-tabs-tab:hover{
    color: #0470e3;
  }
  .query-tp >>> .ivu-tabs .ivu-tabs-tab,
  .query-tp >>> .ivu-tabs .ivu-tabs-tab-active{
    color: #656565;
    font-size: 16px;
    padding: 8px 30px;
  }
  .query-tp >>> .ivu-tabs .ivu-icon-logo-tux,
  .query-tp >>> .ivu-tabs .ivu-icon-logo-windows{
    font-family: inherit;
    background: url("~@/assets/images/home/ai1.png") 0 center no-repeat transparent;
    background-size: 14px;
    width: 16px;
    height: 16px;
    position: relative;
    top: 3px;
    margin-right: 0;
  }
  .query-tp >>> .ivu-tabs .ivu-icon-logo-windows{
    background-image: url("~@/assets/images/home/ai2.png");
  }
  .queryContent .query-header-wrap,
  .results-wrap{
    width: 1400px;
    margin: 0 auto;
    padding-bottom: 20px;
  }
  .queryContent .query-header-wrap{
    padding-top: 20px;
    padding-bottom: 10px;
  }
  .query-slogon{
    margin: 0 0 10px;
    padding-left: 1px;
    font-size: 14px;
    color: #666;
    font-weight: bold;
  }
  .query-inputs{
    position: relative;
    padding-left: 1px;
    padding: 0 20px;
    padding-right: 310px;
  }
  .query-inputs .inputs{
    /* width: 65%; */
  }
  .query-inputs .inputs >>> .search-input-item .title{
    margin-bottom: 0;
  }
  .query-inputs .inputs >>> .search-input-item{
    border-width: 0.5px;
  }
  .btn-wrap{
    position: absolute;
    right: 20px;
    margin-left: 8px;
    bottom: 0;
    padding: 3px 0;
    height: 40px;
  }
  .btn{
    width: 130px;
    border: 1px solid #1F8AFD;
    border-radius: 3px;
    height: 100%;
    float: left;
    /*font-size: 12px;*/
    font-size: 14px;
    text-align: center;
    cursor: pointer;
    position: relative;
  }
  .btn span{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .btn.search{
    border-color: #8892f3;
    background-color: #8892f3;
    color: #fff;
    height: 34px;
    line-height: 34px;
    font-size: 16px;
    letter-spacing: 2px;
    /* transition: all .3s; */
  }
  /* .btn.search:hover{
    border-color: #000;
  } */
  .btn.ivu-btn-loading{
    cursor: default;
  }
  .btn.ivu-btn-loading span{
    position: static;
    transform: none;
  }
  .btn.reset{
    background-color: #fff;
    border-color: #8892f3;
    color: #8892f3;
    margin-left: 20px;
    /* transition: all .3s; */
    height: 34px;
    line-height: 34px;
    font-size: 16px;
    letter-spacing: 2px;
  }
  .btn.reset[disabled]{
    color: #bbbec4;
    /*background-color: #f7f7f7;*/
    border-color: #dddee1;
    cursor: default;
  }
  /* .btn.reset:hover{
    color: #fff;
    border-color: #000;
  } */
  .results{
    background-color:#fff;
    position: relative;
    padding: 23px 0;
  }
  .results-wrap{
    padding-left: 1px;
  }
  .shadow-divide{
    position: absolute;
    top:0;
    left:0;
    width: 100%;
    box-shadow: 0 2px 4px 0 rgba(223,223,223,0.50);
    z-index: 1;
    height: 5px;
    background-color: #fff;
  }
  .results-content{
    /* margin-top: 15px; */
    /*position: relative;*/
    /*padding-right: 235px;*/
  }
</style>




// WEBPACK FOOTER //
// src/components/query/RateE.vue